module.exports = __webpack_public_path__ + "img/coverpage_album_s.7410ca3b.png";